import api from 'api'
import { ACTIVITIES_RECIEVED, ACTIVITIES_SAVED, ACTIVITIES_DELETED, ACTIVITIES_UNLOADED } from './types'

export const activitySaved = data => ({
  type: ACTIVITIES_SAVED,
  data
})

export const activityDataRecieved = data => ({
  type: ACTIVITIES_RECIEVED,
  data
})

export const activityDeleted = data => ({
  type: ACTIVITIES_DELETED,
  data
})

export const actvityDataUnload = () => ({
  type: ACTIVITIES_UNLOADED,
})

export const unloadActivities = () => dispatch => {
  dispatch(actvityDataUnload())
}

export const deleteActivity = data => dispatch =>
  api.bmc.activities.deleteActivity(data).then(()=>{
    dispatch(activityDeleted(data))
  })

export const getActivities = planid => dispatch =>
  api.bmc.activities.getActivities(planid, 'other').then(res => {
    dispatch(activityDataRecieved(res))
  })

export const saveActivity = data => dispatch =>
  api.bmc.activities.postActivity(data).then(res=> {
    dispatch(activitySaved(res))
    return res.id
  })
